import { Routes } from '@angular/router';
import { PmWorkspaceComponent } from './layout/pm-workspace/pm-workspace.component';
import { PmOneLoginAuthGuard } from './features/auth/pm-onelogin-auth.guard';
import { PmNotFoundPageComponent } from './features/not-found/pm-not-found-page.component';
import { environment } from '../environments/environment';

// UI-kit preview gallery (pm-ui Frontend Audit SEC-04): dev/build-time tooling for building and
// demoing shared components, not meant for end users. Spread into the route tree below only when
// not a production build — Dev and Beta are unaffected, and in Production these 8 paths 404 like
// any other unknown address instead of staying reachable to anyone who finds the URL.
const previewRoutes: Routes = environment.production
  ? []
  : [
      {
        path: 'preview',
        loadComponent: () => import('./features/preview/pm-preview-gallery.component').then(m => m.PmPreviewGalleryComponent)
      },
      {
        path: 'preview-table',
        loadComponent: () => import('./features/preview/pm-preview-table/pm-preview-table.component').then(m => m.PmPreviewTableComponent)
      },
      {
        path: 'preview-popups',
        loadComponent: () => import('./features/preview/pm-preview-popups/pm-preview-popups.component').then(m => m.PmPreviewPopupsComponent)
      },
      {
        path: 'preview-fields',
        loadComponent: () => import('./features/preview/pm-preview-fields/pm-preview-fields.component').then(m => m.PmPreviewFieldsComponent)
      },
      {
        path: 'preview-filter',
        loadComponent: () => import('./features/preview/pm-preview-filter/pm-preview-filter.component').then(m => m.PmPreviewFilterComponent)
      },
      {
        path: 'preview-kpis',
        loadComponent: () => import('./features/preview/pm-preview-kpis/pm-preview-kpis.component').then(m => m.PmPreviewKpisComponent)
      },
      {
        path: 'preview-email',
        loadComponent: () => import('./features/preview/pm-preview-email/pm-preview-email.component').then(m => m.PmPreviewEmailComponent)
      },
      {
        path: 'preview-integrations',
        loadComponent: () => import('./features/preview/pm-preview-integrations/pm-preview-integrations.component').then(m => m.PmPreviewIntegrationsComponent)
      },
      {
        path: 'preview-toast',
        loadComponent: () => import('./features/preview/pm-preview-toast/pm-preview-toast.component').then(m => m.PmPreviewToastComponent)
      }
    ];

export const routes: Routes = [
  // Invoice pay page (Capium Pay): opened by the practice's client from the invoice email, who has no PM login — so it
  // sits before, and outside, the guarded tree below. The token in the address is its only key; see pm-api
  // PublicInvoicePayController.
  {
    path: 'pay/:token',
    loadComponent: () => import('./features/invoice-pay/pm-invoice-pay-page.component').then(m => m.PmInvoicePayPageComponent)
  },
  // Guard applied once here via canActivateChild — every child below inherits it automatically,
  // so a new route added later is protected without anyone having to remember to add the guard.
  {
    path: '',
    canActivateChild: [PmOneLoginAuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      ...previewRoutes,
      { path: 'dashboard', component: PmWorkspaceComponent },
      { path: 'clients', component: PmWorkspaceComponent },
      { path: 'document-hub', component: PmWorkspaceComponent },
      { path: 'support-tickets', component: PmWorkspaceComponent },
      // Through the workspace so the page keeps the app's own header; the workspace shows
      // <pm-client-detail-page [embedded]> for it (clientDetailId comes from this URL).
      { path: 'clients/:clientId', component: PmWorkspaceComponent },
      { path: 'deadlines', component: PmWorkspaceComponent },
      { path: 'tasks', component: PmWorkspaceComponent },
      { path: 'tasks/:taskId', component: PmWorkspaceComponent },
      { path: 'notifications', component: PmWorkspaceComponent },
      { path: 'announcements', component: PmWorkspaceComponent },
      { path: 'practice', component: PmWorkspaceComponent },
      { path: 'analytics', component: PmWorkspaceComponent },
      { path: 'crm', component: PmWorkspaceComponent },
      { path: 'reports', component: PmWorkspaceComponent },
      { path: 'reports/:slug', component: PmWorkspaceComponent },
      { path: 'capisign', component: PmWorkspaceComponent },
      { path: 'profile', component: PmWorkspaceComponent },
      { path: 'forgot-password', component: PmWorkspaceComponent },
      { path: 'settings', component: PmWorkspaceComponent },
      // Unknown addresses show a 404 page (with Go back / Go to Dashboard) instead of silently
      // landing on the dashboard. The empty path above still redirects to 'dashboard'.
      { path: '**', component: PmNotFoundPageComponent }
    ]
  }
];
